module.exports = __webpack_public_path__ + "static/media/56.594ba994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/56.jpg
// module id = 617
// module chunks = 0